import {
  Component,
} from '@angular/core';

import { BaseModalComponent } from '../_base-modal.component';
import { UpdateService } from 'shared/update/update.service';


@Component({
  moduleId: module.id,
  selector: 'version-modal',
  templateUrl: 'version-modal.component.html',
  styleUrls: ['version-modal.component.scss'],
})
export class VersionModalComponent extends BaseModalComponent {

  constructor(private updateService: UpdateService) {
    super();
  }
  onRefresh() {
    this.updateService.setIsUpdateDelayed(false);
    this.updateService.updates.activateUpdate().then(() => document.location.reload());
  }
}
